import { post } from '@mindtickle/api-helpers';

export async function updateFreshchatRestoreId(
  companyId: string,
  userId: string,
  restoreId: string
) {
  let url = `/update-freschat-restore-id/${companyId}/${userId}`;
  try {
    const response = await post({ url }, { body: { restoreId } });
    return response;
  } catch (error) {
    return {};
  }
}
